// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
export const ProfileMenuDivider = styled.div `
  border-top: 1px solid var(--color-neutral-300);
  margin: 0px 16px 0px;
`;
export const ProfileMenuContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: absolute;
  visibility: hidden;
  opacity: 0;
  width: 320px;
  padding: 8px 0px;
  top: 56px;
  right: 26px;
  z-index: 1;
  background-color: var(--color-neutral-100);
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.16);
  transition: opacity 0.3s ease-out;

  &.open {
    visibility: visible;
    opacity: 1;
  }
  /* Respiro de 8px entre o card cinza e "Trocar tenant" e entre
     "Assistências" e o divisor do logout. */
  .profile-menu_options {
    .profile-menu-option_item:first-child {
      margin-top: 8px;
    }

    .profile-menu-option_item:last-child {
      margin-bottom: 8px;
    }
  }

  .profile-menu-option_item {
    display: flex;
    align-items: center;
    padding: 8px 24px;
    gap: var(--spacing-size-4xs);
    cursor: pointer;

    /* Caixa fixa: os ícones têm tamanhos próprios e desalinhavam os textos. */
    .root-app_svg {
      display: flex;
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      align-items: center;
      justify-content: center;
    }

    .root-app_svg svg {
      width: 20px;
      height: 20px;
    }

    &.disabled {
      cursor: not-allowed;
      path {
        fill: var(--color-neutral-200);
      }
      span {
        color: var(--color-neutral-200);
      }
    }

    &:not(.disabled) {
      &:hover {
        background-color: var(--color-action-hover);
      }
    }

    &.logout:hover {
      background-color: var(--color-feedback-danger-200);
    }

    span {
      font-size: var(--font-size-default);
      color: var(--color-neutral-600);
    }
  }
  .profile-menu_user {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 4px 24px;

    .username {
      font-size: var(--font-size-default);
      color: var(--color-neutral-500);
      font-weight: var(--font-weight-semibold);
      line-height: 150%;
    }
    .email {
      font-size: var(--font-size-sm);
      color: var(--color-neutral-500);
      line-height: 20px;
    }

    /* Caixa cinza do tamanho do conteúdo, começando na mesma coluna do nome. */
    .profile-menu_tenant {
      display: inline-flex;
      align-self: flex-start;
      align-items: center;
      gap: var(--spacing-size-4xs);
      margin-top: var(--spacing-size-5xs);
      padding: var(--spacing-size-5xs) var(--spacing-size-4xs);
      border-radius: var(--border-radius-default);
      background-color: var(--color-neutral-background);
    }

    .profile-menu_tenant-detail {
      font-size: var(--font-size-sm);
      color: var(--color-neutral-500);
      line-height: 20px;
    }

    /* Caixa cinza do tamanho do conteúdo, começando na mesma coluna do nome. */
    .profile-menu_tenant {
      display: inline-flex;
      align-self: flex-start;
      align-items: center;
      gap: var(--spacing-size-4xs);
      margin-top: var(--spacing-size-5xs);
      padding: var(--spacing-size-5xs) var(--spacing-size-4xs);
      border-radius: var(--border-radius-default);
      background-color: var(--color-neutral-background);
    }

    /* O global de ".root-app_content *" escurece tudo; daí o !important. */
    .profile-menu_tenant-detail strong {
      font-weight: var(--font-weight-semibold);
    }
  }
`;
//# sourceMappingURL=style.js.map